"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../context");

var _colors = require("./colors");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _templateObject, _templateObject2;

var buildBorderWidth = function buildBorderWidth(isTrailing) {
  var borderWidths = isTrailing ? [_constants.PROGRESS_BAR_BORDER_WIDTH, _constants.PROGRESS_BAR_BORDER_WIDTH, _constants.PROGRESS_BAR_BORDER_WIDTH, 0] : [_constants.PROGRESS_BAR_BORDER_WIDTH, 0, _constants.PROGRESS_BAR_BORDER_WIDTH, _constants.PROGRESS_BAR_BORDER_WIDTH];
  return borderWidths.map(function (width) {
    return "".concat(width, "px");
  }).join(' ');
};

var buildBorderRadius = function buildBorderRadius(isTrailing) {
  var borderRadiuses = isTrailing ? [0, _constants.PROGRESS_BAR_BORDER_RADIUS, _constants.PROGRESS_BAR_BORDER_RADIUS, 0] : [_constants.PROGRESS_BAR_BORDER_RADIUS, 0, 0, _constants.PROGRESS_BAR_BORDER_RADIUS];
  return borderRadiuses.map(function (radius) {
    return "".concat(radius, "px");
  }).join(' ');
};

var ProgressBarSegmentOuter = (0, _context.styledWithTheme)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: ", "px;\n  flex: ", ";\n  background-color: ", ";\n  border-color: ", ";\n  border-style: solid;\n  border-width: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n"])), _constants.PROGRESS_BAR_HEIGHT, function (_ref) {
  var widthRatio = _ref.widthRatio;
  return widthRatio;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.selectors.color(_colors.BACKGROUND_COLOR_KEY);
}, function (_ref3) {
  var status = _ref3.status,
      theme = _ref3.theme;
  return (0, _colors.getBorderColor)(status, theme.selectors);
}, function (_ref4) {
  var isTrailing = _ref4.isTrailing;
  return buildBorderWidth(isTrailing);
}, function (_ref5) {
  var isTrailing = _ref5.isTrailing;
  return buildBorderRadius(isTrailing);
});
var ProgressBarSegmentInner = (0, _context.styledWithTheme)('div')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  height: 100%;\n  width: ", "%;\n"])), function (_ref6) {
  var status = _ref6.status,
      theme = _ref6.theme;
  return (0, _colors.getForegroundColor)(status, theme.selectors);
}, function (_ref7) {
  var widthRatio = _ref7.widthRatio;
  return widthRatio;
});

var ProgressBarSegment = function ProgressBarSegment(_ref8) {
  var _ref8$isTrailing = _ref8.isTrailing,
      isTrailing = _ref8$isTrailing === void 0 ? false : _ref8$isTrailing,
      progress = _ref8.progress,
      status = _ref8.status,
      threshold = _ref8.threshold;
  var outerWidthRatio = threshold ? 100 * (isTrailing ? 1.0 - threshold : threshold) : 1;
  var innerWidthThreshold = threshold || 0.5;
  var innerWidthLeft = progress < innerWidthThreshold ? 100 * (progress / innerWidthThreshold) : 100;
  var innerWidthRight = progress < innerWidthThreshold ? 0 : 100 * ((progress - innerWidthThreshold) / (1.0 - innerWidthThreshold));
  var innerWidth = isTrailing ? innerWidthRight : innerWidthLeft;
  return (0, _core.jsx)(ProgressBarSegmentOuter, {
    isTrailing: isTrailing,
    widthRatio: outerWidthRatio,
    status: status
  }, (0, _core.jsx)(ProgressBarSegmentInner, {
    status: status,
    widthRatio: innerWidth
  }));
};

var _default = ProgressBarSegment;
exports.default = _default;